export default "__VITE_ASSET__BaxXRpR___"